module.exports = __webpack_public_path__ + "img/face-disappointed.34a71562.svg";